<template>
  <section class="pt-10" id="destination">
    <div class="container">
      <div class="mb-7 text-center">
        <h3 class="fs-xl-10 fs-lg-8 fs-7 fw-bold font-cursive text-capitalize">All Destinations</h3>
      </div>

      <div class="col-md-12">
        <div class="mb-3">
          <span v-for="(filter, index) in selectedFilters" :key="index">
            <a href="#" @click.prevent="removeFilter(index)"
              :class="{ 'text-muted': index < selectedFilters.length - 1, 'active-filter': index === selectedFilters.length - 1 }">
              {{ filter }} <span class="close-label">&times;</span>
            </a>
            <span v-if="index < selectedFilters.length - 1"> / </span>
          </span>
        </div>

        <div v-if="loading" class="text-center">Loading...</div>
        <div v-else-if="countries.length === 0" class="text-center">No countries available.</div>

        <div v-else>
          <div v-if="selectedCountry && !selectedProvince">
            <ul class="list-unstyled row col-8">
              <li v-for="province in filteredProvinces" :key="province.id"
                class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <a href="#" @click.prevent="fetchCities(province.id, province.name)" class="d-inline"
                  style="color:#0059f1;">
                  {{ province.name }}
                </a>
                <span class="d-inline" style="color:#777; padding-left: 5px;" > ({{ province.placeCount }})</span>
              </li>
            </ul>
          </div>

          <div v-if="selectedProvince && !selectedCity">
            <ul class="list-unstyled row col-8">
              <li v-for="city in filteredCities" :key="city.id" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <a href="#" @click.prevent="placeCity(city.id, city.name)" class="d-inline" style="color:#0059f1;"
                  role="button" tabindex="0">
                  {{ city.name }}
                </a>
                <span class="d-inline" style="color:#777; padding-left: 5px;" >({{ city.placeCount }})</span>
              </li>
            </ul>
          </div>

          <br>
          <div class="">
            <label class="fw-bold text-black">Categories</label><br>
            <span v-for="(filter, index) in selectedFilters2" :key="index">
              <a href="#" @click.prevent="removeFilter2(index)"
                :class="{ 'text-muted': index < selectedFilters2.length - 1, 'active-filter': index === selectedFilters2.length - 1 }">
                {{ filter }} <span class="close-label">&times;</span>
              </a>
              <span v-if="index < selectedFilters.length - 1"> / </span>
            </span>
          </div>

          <div v-if="selectedCountry && !selectedCategory">
            <ul class="list-unstyled d-flex flex-wrap row col-8 mt-2">
              <li v-for="category in filteredCategories" :key="category.id" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                <a href="#" @click.prevent="fetchSubcategories(category.id, category.name)" class="d-inline"
                  style="color:#0059f1;" role="button" tabindex="0">
                  {{ category.name }}
                </a>
                <span class="d-inline" style="color:#777; padding-left: 5px;" >({{ category.placeCount }}) </span>
              </li>
            </ul>
          </div>


          <div v-if="selectedCategory">
            <ul class="list-unstyled d-flex flex-wrap">
              <li v-for="subcategory in filteredSubcategories" :key="subcategory.id" class="me-3 mb-2">
                <a href="#" @click.prevent="placeSubcategory(subcategory.id, subcategory.name)">{{ subcategory.name }}
                  ({{ subcategory.placeCount }}),</a>
              </li>
            </ul>
          </div>

          <div v-if="places.length > 0">
            <h4 class="mt-5"></h4>
            <div class="row ">
              <div v-for="place in places" :key="place.slug" class="col-sm-6 col-md-4 col-lg-3 mb-4">
                <div class="card h-100 overflow-hidden shadow">
                  <div class="card-img-wrapper">
                    <img :src="imageBaseUrl + place.coverImage" :alt="place.name" class="card-img-top" />
                  </div>
                  <div class="card-body py-4 px-3 d-flex flex-column">
                    <h4 class="text-secondary fw-medium mb-3">
                      <a href="#" class="link-900 text-decoration-none stretched-link"
                        @click.prevent="fetchPlaceDetails(place.slug)">
                        {{ place.name }}
                      </a>
                    </h4>
                    <div class="mt-auto">
                      <div class="stars">
                        <span v-for="n in place.randomRating" :key="'filled-' + place.slug + '-' + n"
                          class="star">&#9733;</span>
                        <span v-for="n in (5 - place.randomRating)" :key="'empty-' + place.slug + '-' + n"
                          class="star text-muted">&#9734;</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="selectedCity">No places available in {{ selectedCity }}.</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import $ from 'jquery';
import { useRouter } from 'vue-router';

export default {
  name: 'PlacesListPage',
  data() {
    return {
      countries: [],
      provinces: [],
      cities: [],
      categories: [],
      subcategories: [],
      places: [],
      loading: true,
      selectedFilters: [],
      selectedFilters2: [],
      selectedCountry: null,
      selectedProvince: null,
      selectedCity: null,
      selectedCategory: null,
      selectedSubcategory: null,
    };
  },
  computed: {
    filteredProvinces() {
      return this.selectedProvince ? this.provinces.filter(province => province.name !== this.selectedProvince) : this.provinces;
    },
    filteredCities() {
      return this.selectedCity ? this.cities.filter(city => city.name !== this.selectedCity) : this.cities;
    },
    filteredCategories() {
      return this.selectedCategory ? this.categories.filter(category => category.name !== this.selectedCategory) : this.categories;
    },
    filteredSubcategories() {
      return this.selectedSubcategory ? this.subcategories.filter(subcategory => subcategory.name !== this.selectedSubcategory) : this.subcategories;
    },
    imageBaseUrl() {
    return process.env.VUE_APP_URL + '/images/';
  }
  },
  mounted() {
    this.fetchCountries();
    this.fetchSriLankaPlaces();
  },
  methods: {
    fetchSriLankaPlaces() {
      this.loading = true;
      $.ajax({
        url: process.env.VUE_APP_API_URL +`/getPlacesByCountry`, // Adjust the API endpoint accordingly
        type: 'GET',
        dataType: 'json',
        success: (response) => {
          this.places = response.map(place => {
            place.randomRating = this.randomRating(); // Assuming randomRating is a method you have defined
            return place;
          });
          this.loading = false;
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching Sri Lanka places:', textStatus, errorThrown);
          this.loading = false;
        },
      });
    },
    fetchCountries() {
      this.loading = true;
      this.selectedFilters2 = [],
        $.ajax({
         url: process.env.VUE_APP_API_URL +'/getEnableCountry',
          type: 'GET',
          dataType: 'json',
          success: (response) => {
            this.countries = response;
            this.loading = false;
            // Automatically fetch provinces for the first country if available
            if (this.countries.length > 0) {
              this.fetchProvinces(this.countries[0].id, this.countries[0].name);

            }
          },
          error: (jqXHR, textStatus, errorThrown) => {
            console.error('Error fetching countries:', textStatus, errorThrown);
            this.loading = false;
          },
        });
    },

    // When a province is clicked
    fetchProvinces(countryId, countryName) {
      this.selectedCountry = countryName;
      this.selectedFilters.push(countryName);
      this.selectedFilters2 = [],
        this.loading = true;
      this.provinces = []; // Clear previous provinces
      this.cities = []; // Clear cities when fetching new provinces
      this.places = []; // Clear places when fetching new provinces

      $.ajax({
        url: process.env.VUE_APP_API_URL +'/getProvinces/${countryId}',
        type: 'GET',
        dataType: 'json',
        success: (response) => {
          this.provinces = response.filter(province => province.name.includes("Province"))
            .map(province => {
              // Remove 'Province' from the name
              return {
                ...province,
                name: province.name.replace("Province", "").trim()
              };
            });
          this.loading = false;
          this.fetchCategories(); // Fetch categories after provinces


          // Fetch places based on the selected country after fetching provinces
          this.fetchPlaces();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching provinces:', textStatus, errorThrown);
          this.loading = false;
        },
      });
    },

    // When a city is clicked
    fetchCities(provinceId, provinceName) {
      this.selectedProvince = provinceName;
      this.selectedFilters.push(provinceName);
      this.loading = true;
      this.cities = [];

      $.ajax({
        url: process.env.VUE_APP_API_URL +`/getCities/${provinceId}`,
        type: 'GET',
        dataType: 'json',
        success: (response) => {
          this.cities = response.filter(cities => !cities.name.endsWith('District'));
          this.loading = false;

          this.fetchCategories(); // Fetch categories after provinces
          this.fetchSubcategories();
          this.selectedFilters2 = [];
          // Fetch places based on the selected country and province after fetching cities
          this.fetchPlaces();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching cities:', textStatus, errorThrown);
          this.loading = false;
        },
      });
    },

    placeCity(cityID, cityName) {
      this.selectedCity = cityName;
      this.selectedFilters.push(cityName);
      this.loading = true;
      this.selectedFilters2 = [];
      this.fetchCategories();
      this.fetchSubcategories();
      this.fetchPlaces();
    },

    placeSubcategory(subcategoryId, subcategoryName) {
      this.selectedSubcategory = subcategoryName;
      this.selectedFilters2.push(subcategoryName);
      this.loading = true;
    },

    fetchCategories() {
      this.loading = true;
      const params = {};
      // Add filters based on selections
      if (this.selectedCountry) {
        // Find the selected country's name
        const country = this.countries.find(country => country.name === this.selectedCountry);
        if (country) {
          params.country_id = country.name; // Use the country ID as the parameter
          console.log('Selected Country:', params.country_id);

        }
      }

      if (this.selectedProvince) {
        // Find the selected province's name
        const province = this.provinces.find(province => province.name === this.selectedProvince);
        if (province) {
          params.province_id = province.name; // Use the province ID as the parameter
          console.log('Selected Province:', params.province_id);
        }
      }

      if (this.selectedCity) {
        // Find the selected city's ID
        const city = this.cities.find(city => city.name === this.selectedCity);
        if (city) {
          params.city_id = city.name; // Use the city ID as the parameter
          console.log('Selected City ID:', params.city_id);
        }
      }
      $.ajax({
       url: process.env.VUE_APP_API_URL +'/getPlaceCategories',
        data: params, // Send the parameters as query string
        dataType: 'json',
        success: (response) => {
          this.categories = response;
          this.fetchPlaces();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching categories:', textStatus, errorThrown);
        },
      });
    },

    fetchSubcategories(categoryId, categoryName) {
      this.selectedCategory = categoryName;
      this.selectedFilters2.push(categoryName);
      this.loading = true;
      this.subcategories = [];

      const params = {};
      // Add filters based on selections
      if (this.selectedCountry) {
        // Find the selected country's name
        const country = this.countries.find(country => country.name === this.selectedCountry);
        if (country) {
          params.country_id = country.name; // Use the country ID as the parameter
          console.log('Selected Country:', params.country_id);

        }
      }

      if (this.selectedProvince) {
        // Find the selected province's name
        const province = this.provinces.find(province => province.name === this.selectedProvince);
        if (province) {
          params.province_id = province.name; // Use the province ID as the parameter
          console.log('Selected Province:', params.province_id);
        }
      }

      if (this.selectedCity) {
        // Find the selected city's ID
        const city = this.cities.find(city => city.name === this.selectedCity);
        if (city) {
          params.city_id = city.name; // Use the city ID as the parameter
          console.log('Selected City ID:', params.city_id);
        }
      }

      if (this.selectedCategory) {
        // Find the selected city's ID
        const category = this.categories.find(category => category.name === this.selectedCategory);
        if (category) {
          params.category_id = category.id; // Use the city ID as the parameter
          console.log('Selected Category ID:', params.category_id);
        }
      }

      $.ajax({
        url: process.env.VUE_APP_API_URL +`/getPlaceSubcategories`,
        data: params, // Send the parameters as query string
        dataType: 'json',
        success: (response) => {
          this.subcategories = response;
          this.loading = false;
          this.fetchPlaces();
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching subcategories:', textStatus, errorThrown);
          this.loading = false;
        },
      });
    },


    fetchPlaces() {
      // this.selectedFilters.push($cityName);
      this.loading = true;
      // this.selectedFilters.push($cityName);

      // Start building the URL based on selected filters
      let url = process.env.VUE_APP_API_URL+`/fetchPlaces`;

      // Create an object to hold filter parameters
      const params = {};

      // Add filters based on selections
      if (this.selectedCountry) {
        // Find the selected country's name
        const country = this.countries.find(country => country.name === this.selectedCountry);
        if (country) {
          params.country_id = country.name; // Use the country ID as the parameter
          console.log('Selected Country:', params.country_id);
        }
      }

      if (this.selectedProvince) {
        // Find the selected province's name
        const province = this.provinces.find(province => province.name === this.selectedProvince);
        if (province) {
          params.province_id = province.name + ' Province'; // Use the province ID as the parameter
          console.log('Selected Province:', params.province_id);
        }
      }

      if (this.selectedCity) {
        // Find the selected city's ID
        const city = this.cities.find(city => city.name === this.selectedCity);
        if (city) {
          params.city_id = city.name; // Use the city ID as the parameter
          console.log('Selected City ID:', params.city_id);
        }
      }
      if (this.selectedCategory) {
        params.category_id = this.selectedCategory.id; // Add category parameter
      }
      if (this.selectedSubcategory) {
        params.subcategory_id = this.selectedSubcategory.id; // Add subcategory parameter
      }

      // Make the AJAX call with parameters
      $.ajax({
        url: url,
        type: 'GET',
        data: params, // Send the parameters as query string
        dataType: 'json',
        success: (response) => {
          this.places = response.map(place => {
            place.randomRating = this.randomRating(); // Assuming randomRating is a method you have defined
            return place;
          });
          this.loading = false;
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching places:', textStatus, errorThrown);
          this.loading = false;
        },
      });
    },

    removeFilter(index) {
      const removedFilter = this.selectedFilters[index]; // Get the removed filter

      // Remove the filter from the selectedFilters array
      this.selectedFilters.splice(index, 1);

      // Update the selections based on the remaining filters
      this.updateSelections();

      // Fetch places based on remaining selections
      this.fetchPlaces(); // Call fetchPlaces to update the places based on remaining filters

      // Reset province and city if country is removed
      if (removedFilter === this.selectedCountry) {
        this.selectedCountry = null;
        this.provinces = []; // Clear provinces
        this.cities = []; // Clear cities
      } else if (removedFilter === this.selectedProvince) {
        this.selectedProvince = null;
        this.cities = []; // Clear cities
      } else if (removedFilter === this.selectedCity) {
        this.selectedCity = null;
      }
    }
    ,

    updateSelections() {
      this.selectedCountry = this.selectedFilters[0] || null;
      this.selectedProvince = this.selectedFilters[1] || null;
      this.selectedCity = this.selectedFilters[2] || null;


      // Clear places when any filter is removed
      if (!this.selectedCity) {
        this.places = [];
      }
    },

    fetchPlaceDetails(slug) {
      $.ajax({
        url: process.env.VUE_APP_API_URL +`/place/${slug}`,
        type: 'GET',
        dataType: 'json',
        success: (response) => {
          // Navigate to detail page using Vue Router
          this.$router.push({ path: `/place`, query: { slug: response.slug } });
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.error('Error fetching place details:', textStatus, errorThrown);
        },
      });
    },

    randomRating() {
      return Math.floor(Math.random() * 5) + 1; // Generates a random rating between 1 and 5
    },
  },
};
</script>

<style scoped>
/* Add your component styles here */
.star {
  color: gold;
  /* Color for filled stars */
}

.text-muted {
  color: gray;
  /* Style for disabled filters */
  pointer-events: none;
  /* Prevent clicking */
}

.active-filter {
  font-weight: bold;
  /* Highlight the active filter */
  color: rgb(36, 36, 37);
  /* Change color for active filter */
}

.close-label {
  margin-left: 5px;
  /* Space between filter text and close label */
  cursor: pointer;
  /* Change cursor to pointer for close label */
  color: red;
  /* Color for the close label */
}

.card-img-wrapper {
  width: 100%;
  padding-top: 75%;
  /* Aspect ratio: 4:3 (adjust for your needs) */
  position: relative;
}

.card-img-top {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Ensures images fill the space without distortion */
}

.card {
  height: 100%;
  /* Make the card fill the height of the parent */
}

.stars {
  display: flex;
  gap: 3px;
}
</style>
